// src/hooks/useSidebarState.ts
import { create } from 'zustand';

type SidebarState = {
  isCollapsed: boolean;
  isMobileOpen: boolean;
  toggle: () => void;
  toggleMobile: () => void;
  closeMobile: () => void;
  setCollapsed: (collapsed: boolean) => void;
};

export const useSidebarState = create<SidebarState>((set) => ({
  isCollapsed: false,
  isMobileOpen: false,
  toggle: () => set((state) => ({ 
    isCollapsed: !state.isCollapsed
  })),
  toggleMobile: () => set((state) => ({
    isMobileOpen: !state.isMobileOpen
  })),
  closeMobile: () => set({ isMobileOpen: false }),
  setCollapsed: (collapsed) => set({ isCollapsed: collapsed })
}));
